import { useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";
import { FormInput } from "@/shared/components";

export function Number(props: { pending: boolean }) {
  const { pending } = props;

  const {
    formState: { errors },
  } = useFormContext();

  const getErrorText = () => {
    if (
      errors.number_of_channel?.type === "required" ||
      errors.number_of_channel?.type === "validate"
    ) {
      return "This field must contain 2-100 symbols";
    }

    return null;
  };

  return (
    <FormInput
      name="number_of_channel"
      rules={{
        required: true,
        validate: (value) => {
          const trimmedValue = (value || "").trim();
          const validValue =
            trimmedValue.length >= 2 && trimmedValue.length <= 100;

          return validValue;
        },
      }}
      render={({ field }) => (
        <TextField
          {...field}
          fullWidth
          label="ID or phone number in that channel"
          variant="filled"
          disabled={pending}
          error={!!getErrorText()}
          helperText={getErrorText()}
        />
      )}
    />
  );
}
